<template>
  <div class="bg-white text-tdefault-color">
    <section class="checkout pt-4 mx-auto w-10/12 pb-12">
      <!-- Checkout Page top section -->
      <div class="grid grid-rows">
        <div
          class="my-2 text-primary-default flex cursor-pointer text-sm md:text-base lg:text-base font-bold"
          @click.prevent="goToCatalog"
        >
          <ArrowLeftIcon class="h-5 w-5 flex-shrink-0 mr-2 text-primary-default" aria-hidden="true" />
          {{ buttonText }}
        </div>
        <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4">Bestellijst</div>
      </div>
      <!-- Depot Issue Checkbox section -->
      <div class="grid grid-rows mb-4 border-b broder-bdefault pb-6 rounded" v-if="showDepotIssueBlock">
        <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4">Depot uitgifte</div>
        <div class="">
          <v-checkbox-group
            class="font-bold"
            label="Ik geef alle producten mee aan patiënt, graag depot bijvullen"
            :inputid="'checkDepotIssue'"
            :overwrite-value="depotIssueCheckboxChecked"
            :initvalue="depotIssueCheckboxChecked"
            v-model="depotIssueCheckboxChecked"
          />
        </div>
      </div>
      <!-- Products section -->
      <div class="grid grid-rows gap-4 mb-4 border-b broder-bdefault pb-6 rounded" id="checkoutProducts">
        <v-checkout-product
          class="border broder-bdefault rounded-lg shadow"
          v-for="shoppingCartItem in shoppingCart.items"
          :key="shoppingCartItem.productId"
          :product="shoppingCartItem"
          @update="handleShoppingCartItemUpdate"
          @remove="handleShoppingCartItemRemove"
          @add="handleShoppingCartItemAdd"
          ref="checkoutProduct"
        ></v-checkout-product>
      </div>
      <!-- Rest of the checkout page -->
      <div class="grid grid-rows gap-4">
        <!-- Addresses section -->
        <div v-if="showAddress && !assortmentFeatureEnabled" class="grid grid-rows" id="checkoutLevering">
          <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4">Levering</div>
          <div class="grid grid-rows gap-4 border-b broder-bdefault pb-6 rounded mb-4">
            <div class="grid grid-rows md:grid-cols-3">
              <div>
                <legend class="mb-2 font-bold">Gewenste afleverlocatie</legend>
                <div class="form-group__radio">
                  <input id="homeAddress" name="deliveryaddress" type="radio" checked @change="checkRadioAddress" />
                  <label for="homeAddress"><span></span>Woonadres</label>
                </div>
                <div v-if="deliveryAddress && deliveryAddress.AdresId !== 0" class="form-group__radio">
                  <input id="deliveryAddress" name="deliveryaddress" type="radio" @change="checkRadioAddress" />
                  <label for="deliveryAddress"><span></span>Afwijkend afleveradres</label>
                </div>
                <div class="form-group__radio">
                  <input id="differentAddress" name="deliveryaddress" type="radio" @change="checkRadioAddress" />
                  <label for="differentAddress"><span></span>Eenmalig afwijkend adres</label>
                </div>
              </div>
              <div class="md:col-span-2 lg:col-span-1">
                <legend class="mb-2 font-bold mt-4 md:mt-0">Afleveradres</legend>
                <div class="grid grid-rows gap-1 mb-4" v-if="SelectedAddress === 0 || SelectedAddress === 1">
                  <div class="">
                    <span class="mr-2">{{ activeAddress.Straatnaam }}</span>
                    <span class="mr-2">{{ activeAddress.Huisnummer }}</span>
                    <span class="mr-2">{{ activeAddress.Toevoeging }}</span>
                  </div>
                  <div class="">
                    <span class="mr-2">{{ activeAddress.Postcode }}</span>
                    <span class="mr-2"> {{ activeAddress.Woonplaats }}</span>
                    <span class="mr-2">{{ activeAddress.Land }}</span>
                  </div>
                </div>
                <div class="grid grid-rows" v-if="SelectedAddress === 2">
                  <div class="grid grid-cols-3 gap-4 mb-4">
                    <div class="">
                      <v-input-group-simple-2
                        id="Postcode"
                        v-model:value="differentAddress.PostCode"
                        type="text"
                        maxlength="7"
                        :rules="{
                          required: true,
                          regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
                        }"
                        label="Postcode"
                        @blur="autoFillAddress()"
                        @input="updateAddressDetails('PostCode', $event)"
                      />
                    </div>
                    <div class="">
                      <v-input-group-simple-2
                        id="Huisnummer"
                        v-model:value="differentAddress.Huisnummer"
                        type="text"
                        :rules="{
                          required: true
                        }"
                        label="Huisnr"
                        @blur="autoFillAddress()"
                        @input="updateAddressDetails('Huisnummer', $event)"
                      />
                    </div>
                    <div class="">
                      <v-input-group-simple-2
                        id="Toevoeging"
                        v-model:value="differentAddress.Toevoeging"
                        type="text"
                        :rules="{
                          required: false
                        }"
                        label="Toevoeging"
                        @input="updateAddressDetails('Toevoeging', $event)"
                      />
                    </div>
                  </div>
                  <div class="grid grid-cols-2 gap-4 mb-4">
                    <div class="">
                      <v-input-group-simple-2
                        id="Straatnaam"
                        v-model:value="differentAddress.Straatnaam"
                        type="text"
                        :rules="{
                          required: true
                        }"
                        label="Straatnaam"
                        :disabled="addressLookupSuccessful"
                        @input="updateAddressDetails('Straatnaam', $event)"
                      />
                    </div>
                    <div class="">
                      <v-input-group-simple-2
                        id="Woonplaats"
                        v-model:value="differentAddress.Woonplaats"
                        type="text"
                        :rules="{
                          required: true
                        }"
                        label="Woonplaats"
                        :disabled="addressLookupSuccessful"
                        @input="updateAddressDetails('Woonplaats', $event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showNeighborsDeliveryAllowed" class="mt-4">
              <legend class="font-bold mb-2">Niemand thuis?</legend>
              <div>
                <v-checkbox-group
                  class="font-bold"
                  label="Ik geef toestemming om mijn pakket af te geven bij de buren"
                  inputid="NeighborsDeliveryAllowed"
                  :initvalue="neighborDeliveryStatus"
                  v-model="neighborDeliveryStatus"
                  :overwrite-value="neighborDeliveryStatus"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Order Number section -->
        <div class="grid grid-rows" v-if="assortmentFeatureEnabled">
          <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4">Ordernummer</div>
          <div class="border-b broder-bdefault pb-6 rounded">
            <div class="grid grid-rows">
              <div class="w-96">
                <v-input-group-simple-2
                  id="Ordernummer"
                  v-model:value="orderNumberModel"
                  maxlength="128"
                  :rules="{
                    required: false,
                    regex: /^[a-zA-Z0-9]*$/i
                  }"
                  placeholder="Vul hier uw ordernummer of betalingskenmerk in."
                  class="orderNummer"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Kies uw gewenste bezorgmoment section -->
        <div class="grid grid-rows" v-if="deliveryDateFeature && possibleDeliveryDates.length > 0" id="deliveryTimings">
          <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4">Bezorgmoment</div>
          <p class="text-base font-bold">Kies uw gewenste bezorgmoment</p>
          <div class="border-b broder-bdefault pb-6 rounded">
            <div class="grid grid-rows">
              <div class="w-fit min-w-44">
                <v-select-group
                  selectid="PossibleDeliveryDates"
                  :initselected="possibleDeliveryDates[0].Key"
                  :overwrite-value="possibleDeliveryDates[0].Key"
                  @change="setSelectedDeliveryDate($event)"
                >
                  <option
                    v-for="(item, index) in possibleDeliveryDates"
                    :key="index"
                    :data-index="index"
                    :value="item.Key"
                  >
                    {{ item.Value }}
                  </option>
                </v-select-group>
              </div>
              <div v-if="showTimeWindowCheck" class="mt-4">
                <v-checkbox-group
                  class="font-bold"
                  v-model="isTimeWindowDelivery"
                  label="Eerst mogelijke bezorgmoment op deze dag"
                  :overwrite-value="isTimeWindowDelivery"
                  inputid="timeWindow"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- FAQs Section -->
        <div class="grid grid-rows" v-if="!assortmentFeatureEnabled">
          <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4">Veelgestelde vragen</div>
          <div class="border broder-bdefault rounded-lg shadow">
            <v-faq-row
              v-for="(faq, index) in faqsByCustomFilter"
              :key="index"
              :faq="faq"
              :index="index"
              :total-faq="faqsByCustomFilter.length"
            />
          </div>
          <div
            class="my-4 text-primary-default flex cursor-pointer text-sm md:text-base lg:text-base"
            @click.prevent="$router.push('/service#Question')"
          >
            Alle veelgestelde vragen
            <ArrowRightIcon class="h-5 w-5 flex-shrink-0 ml-2 text-primary-default" aria-hidden="true" />
          </div>
        </div>
        <!-- Remarks section -->
        <div class="grid grid-rows mb-4">
          <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4">Opmerkingen (Optioneel)</div>
          <div>
            <div class="font-bold text-base text-talternative-color mb-2">Soort opmerking</div>
            <combo-boxes
              id="remarkTypeOptions"
              disabledInput
              v-model="remarkType"
              :list="remarkTypeOptions"
              class="w-72"
            ></combo-boxes>
          </div>
          <div v-if="remarkType.id !== null">
            <textarea
              id="checkout-remarks"
              class="border broder-bdefault shadow rounded-lg p-4 min-h-20 outline-none w-full"
              placeholder="Opmerkingen"
              @input="setRemarks($event.target.value)"
            />
          </div>
        </div>
      </div>
      <!-- Checkout Action section -->
      <div class="grid grid-rows justify-end mt-2 justify-items-end mb-10" id="checkoutOrder">
        <button
          @click.prevent="saveCheckout()"
          class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-xs md:text-sm lg:text-sm font-medium text-white bg-cta rounded-full hover:bg-primary-default/50 mb-2 fixed bottom-20 z-50"
        >
          <span class="">Bestelling afronden</span>
        </button>
      </div>
      <!-- Modals section -->
      <generic-modal v-if="noProductOverlay">
        <template #header> Let op! </template>
        <template #body>
          <p>{{ popupMessage }}</p>
        </template>
        <template #footer>
          <v-button md hollow transparent @click="closeModal"> Annuleren </v-button>
          <v-button md primary @click="goToCatalog()"> Bevestigen </v-button>
        </template>
      </generic-modal>
    </section>
  </div>
</template>

<script>
import router from '@/router';
import VCheckoutProduct from './CheckoutProduct';
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup';
import VFaqRow from './FaqRow';
import GenericModal from '@/components/shared/GenericModal';
import { useForm } from 'vee-validate';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/vue/20/solid';
import {
  removeFromShoppingCart,
  activeCustomerId$,
  shoppingCart$,
  addToShoppingCart,
  clearShoppingCart,
  updateShoppingCartItem,
  currentUserIdentity$,
  activePpwRecId$,
  assortmentFeatureEnabled$,
  checkout,
  checkoutSuccessful$
} from '@/services';
import { BehaviorSubject } from 'rxjs';
import { tap, filter, map, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { $validateAllComponents } from '@/validate/index.js';
import { computed, ref, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'Checkout',
  components: {
    VCheckoutProduct,
    VCheckboxGroup,
    VFaqRow,
    GenericModal,
    ArrowLeftIcon,
    ArrowRightIcon
  },
  setup() {
    const instance = getCurrentInstance();
    const store = useStore();
    const { validate } = useForm();
    const shoppingCart = ref(null);
    const shoppingCartChanged = ref(null);
    const assortmentFeatureEnabled = ref(null);
    const activeCustomerId = ref(null);
    const prescriberDetails = ref(null);
    const activePpwRecId = ref(null);
    const noProductOverlay = ref(false);
    const popupMessage = ref(null);
    const submitOrderPopupMessage = ref(null);
    const orderNumberModel = ref('');
    const isTimeWindowDelivery = ref(false);
    const addressLookup = ref(null);
    const checkDepotIssue = ref(false);
    const remarkTypeOptions = ref([
      { id: null, data: 'Selecteer soort opmerking' },
      { id: 1, data: 'Afleverinstructie' },
      { id: 2, data: 'Herhaalbestelling' },
      { id: 3, data: 'Patient mag zelf bestellen' },
      { id: 4, data: 'Product specifieke opmerking' },
      { id: 5, data: 'Overig' }
    ]);
    const remarkType = ref({ id: null, data: 'Selecteer soort opmerking' });

    const neighborDeliveryStatus = computed({
      get: () => store.getters['cart/getNeighborsDeliveryAllowed'],
      set: (value) => store.commit('cart/setNeighborsDeliveryAllowed', value)
    });
    const repeatServiceStatus = computed({
      get: () => store.getters['cart/getRepeatService'],
      set: (value) => store.commit('cart/setRepeatService', value)
    });
    const homeAddress = computed(() => store.getters['cart/getCheckoutHomeAddress']);
    const deliveryAddress = computed(() => store.getters['cart/getCheckoutDeliveryAddress']);
    const differentAddress = computed(() => store.getters['cart/getCheckoutDifferentAddress']);
    const siteCode = computed(() => store.getters['navigation/getSiteCode']);
    const SelectedAddress = computed(() => store.getters['cart/getSelectedAddress']);
    const orderNumber = computed(() => store.getters['cart/getOrderNumber']);
    const faqs = computed(() => store.getters['cart/getFaqs']);
    const leveringOptions = computed(() => store.getters['cart/getLeveringOptions']);
    const remarks = computed(() => store.getters['cart/getRemarks']);
    const userMarketingPermission = computed(() => store.getters['navigation/getUserMarketingPermission']);

    const buttonText = computed(() => store.getters['cart/getButtonText']);
    const possibleDeliveryDates = computed(() => store.getters['cart/getPossibleDeliveryDates']);
    const userWarehouseStatus = computed(() => store.getters['cart/getUserWarehouseStatus']);
    const addressLookupSuccessful = computed(() => {
      return addressLookup.value !== null;
    });
    const faqsByCustomFilter = computed(() => {
      const computedFaqs = faqs.value;
      return computedFaqs ? (computedFaqs.length > 5 ? computedFaqs.slice(0, 5) : computedFaqs) : [];
    });
    const requireDelivery = computed(() => {
      var itemsNotGivenToPatient = shoppingCart.value.items.filter((item) => item.givenToPatient !== true);
      return itemsNotGivenToPatient.length > 0;
    });
    const deliveryDateFeature = computed(() => {
      return shoppingCart.value.items.filter((item) => item.givenToPatient !== true).length > 0;
    });
    const showNeighborsDeliveryAllowed = computed(() => {
      return requireDelivery.value;
    });
    const showAddress = computed(() => {
      return requireDelivery.value;
    });
    const showTimeWindowCheck = computed(() => {
      return shoppingCart.value.items.every((item) => item.isNutritionProduct === false) &&
        store.state.cart.selectedDeliveryDate === possibleDeliveryDates.value[0].Key
        ? true
        : false;
    });
    const depotIssueCheckboxChecked = computed({
      get() {
        for (let i = 0; i < shoppingCart.value.items.length; i++) {
          var itemRef = shoppingCart.value.items[i];
          if (!itemRef.supportGivenToPatient) {
            continue;
          }

          if (!itemRef.givenToPatient || !itemRef.fillUpStock) {
            return false;
          }
        }
        return true;
      },
      set(value) {
        for (let i = 0; i < shoppingCart.value.items.length; i++) {
          var itemRef = shoppingCart.value.items[i];
          if (itemRef.supportGivenToPatient && itemRef.givenToPatient != value) {
            itemRef.givenToPatient = value;

            if (itemRef.supportFillUpStock) {
              itemRef.fillUpStock = value;
            }

            handleShoppingCartItemUpdate(itemRef);
          }
        }
      }
    });
    const customerMarketingPermission = computed(() => {
      let status = false;
      if (userMarketingPermission.value !== null) {
        for (let key in userMarketingPermission.value) {
          if (userMarketingPermission.value[key]) {
            status = true;
            break;
          }
        }
      }
      return status;
    });
    const showDepotIssueBlock = computed(() => {
      return (
        userWarehouseStatus.value &&
        !isCTypeMaterialAvailable.value &&
        !shoppingCart.value.items.some((item) => item.isNutritionProduct) &&
        !shoppingCart.value.items.some((item) => item.isDiabetesProduct)
      );
    });
    const isConsignmentOrder = computed(() => {
      if (router.currentRoute.value.name == 'aanvullenmagazijnCheckout') {
        return true;
      }
      return false;
    });
    const activeAddress = computed(() => {
      if (SelectedAddress.value === 0) return homeAddress.value;
      if (SelectedAddress.value === 1 && deliveryAddress && deliveryAddress.value.AdresId !== 0)
        return deliveryAddress.value;
      return null;
    });

    const isCTypeMaterialAvailable = ref(store.state.navigation.cTypeMaterials);
    const fetchCheckoutDetailsStore = (requiredIds) => store.dispatch('cart/fetchCheckoutDetails', requiredIds);
    const setSelectedAddress = (value) => store.commit('cart/setSelectedAddress', value);
    const setOrderNumber = (value) => store.commit('cart/setOrderNumber', value);
    const setRepeatService = (value) => store.commit('cart/setRepeatService', value);
    const setNeighborsDeliveryAllowed = (value) => store.commit('cart/setNeighborsDeliveryAllowed', value);
    const setRemarks = (value) => store.commit('cart/setRemarks', value);
    const setLeveringSubOptions = (value) => store.commit('cart/setLeveringSubOptions', value);
    const setLeveringOptions = (value) => store.commit('cart/setLeveringOptions', value);
    const setCustomerMarketingPermissionSubOption = (value) =>
      store.commit('patient/setCustomerMarketingPermissionSubOption', value);
    const fetchAddressLookup = (value) => store.dispatch('patient/fetchAddressLookup', value);
    store.dispatch('cart/fetchPossibleDeliveryDates');

    shoppingCart$.subscribe((value) => (shoppingCart.value = value));
    shoppingCart$
      .pipe(
        map((m) => (m ? m.items.length : 0)),
        distinctUntilChanged(),
        filter((m) => m > 0)
      )
      .subscribe((value) => (shoppingCartChanged.value = value));

    assortmentFeatureEnabled$.subscribe((value) => (assortmentFeatureEnabled.value = value));
    assortmentFeatureEnabled$
      .pipe(
        switchMap((enabled) => {
          return enabled ? new BehaviorSubject(null) : activeCustomerId$;
        })
      )
      .subscribe((value) => (activeCustomerId.value = value));

    currentUserIdentity$.subscribe((value) => (prescriberDetails.value = value));
    activePpwRecId$.subscribe((value) => (activePpwRecId.value = value));
    checkoutSuccessful$
      .pipe(
        tap((e) => {
          router.push({
            path: '/orderconfirmation',
            query: {
              orderId: e.data.orderIds
            }
          });
          return null;
        })
      )
      .subscribe();
    // Dispatching server calls to fetch Prescriber, Patient details
    // and using those details to fetch checkout page required details
    store.dispatch('navigation/fetchResults').then(() => {
      if (!assortmentFeatureEnabled.value) {
        fetchCheckoutDetails();
      } else {
        fetchCheckoutDetails();
      }
    });

    const fetchCheckoutDetails = () => {
      let requiredIds = {
        prescriberId: prescriberDetails.value.id,
        patientId: activeCustomerId.value
      };
      fetchCheckoutDetailsStore(requiredIds).then((response) => {
        popupMessage.value = response.DeleteProductPopupMessage;
        noProductOverlay.value = false;
        /*
          // Original code: it is showing the wrong popup. Once fixed we can put the code back in although needs to be based on observable, not on promise.
          response.DeleteProductPopupMessage &&
          (!this.shoppingCart || (this.shoppingCart.items && this.shoppingCart.items.length === 0));
        */
        submitOrderPopupMessage.value = response.SubmitOrderPopupMessage;
      });
    };
    const updateAddressDetails = (key, event) => {
      differentAddress.value[key] = event.target.value;
    };
    const closeModal = () => {
      noProductOverlay.value = false;
    };
    const handleShoppingCartItemUpdate = (item) => {
      updateShoppingCartItem(shoppingCart.value, item, activePpwRecId.value);
    };
    const handleShoppingCartItemRemove = (item) => {
      const index = shoppingCart.value.items.indexOf(item);
      if (index >= 0) {
        shoppingCart.value.items.splice(index, 1);
      }
      removeFromShoppingCart(shoppingCart.value, item.cartId);
    };
    const handleShoppingCartItemAdd = (item) => {
      addToShoppingCart(shoppingCart.value, item.productId, item.count, activePpwRecId.value);
    };
    const handleClearShoppingCart = () => {
      clearShoppingCart(shoppingCart.value).then(() => {
        closeModal();
      });
    };
    const internalSaveCheckout = (customerId) => {
      let command = {
        customerId: customerId,
        deliveryDate: store.state.cart.selectedDeliveryDate,
        remarkType: remarkType.value.id ? remarkType.value.id : null,
        remark: store.state.cart.checkoutDetails.Remarks,
        orderNumber: store.state.cart.checkoutDetails.orderNumber,
        NeighborsDeliveryAllowed: neighborDeliveryStatus.value,
        addressType: store.state.cart.checkoutDetails.SelectedAddress,
        CustomerMarketingPermission: null,
        address: null,
        isConsignmentOrder: false
      };
      if (store.state.cart.checkoutDetails.SelectedAddress === 0) {
        command.address = store.state.cart.checkoutDetails.HomeAddress;
      }
      if (store.state.cart.checkoutDetails.SelectedAddress === 1) {
        command.address = store.state.cart.checkoutDetails.DeliveryAddress;
      }
      if (store.state.cart.checkoutDetails.SelectedAddress === 2) {
        command.address = store.state.cart.checkoutDetails.DifferentAddress;
      }
      Object.keys(command.address).forEach((key) => {
        let newKey = key.toLowerCase();
        command.address[newKey] = command.address[key];
        delete command.address[key];
      });
      if (store.state.patient.customerMarketingPermission) {
        command.CustomerMarketingPermission = store.state.patient.customerMarketingPermission;
      } else {
        command.CustomerMarketingPermission = store.state.patient.patientGegevens.CustomerMarketingPermission;
      }
      command.isTimeWindowDelivery = isTimeWindowDelivery.value;
      command.isConsignmentOrder = isConsignmentOrder.value;
      return checkout(command);
    };

    const saveCheckout = () => {
      $validateAllComponents(instance.proxy).then((result) => {
        if (result === false) {
          // Form is invalid. Exiting.
          return;
        }
        if (SelectedAddress.value === 2 || assortmentFeatureEnabled.value) {
          // Only difference in original code was that `validateFields` set the country - looks lke we can assume it is always NL.
          differentAddress.value.Land = 'NL';
        }
        if (assortmentFeatureEnabled.value) {
          setOrderNumber(orderNumberModel);
        }
        internalSaveCheckout(shoppingCart.value.customerId);
      });
    };
    const checkRadioAddress = (e) => {
      let checkedAddress = document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id;
      if (checkedAddress === 'homeAddress') {
        setSelectedAddress(0);
      }
      if (checkedAddress === 'deliveryAddress') {
        setSelectedAddress(1);
      }
      if (checkedAddress === 'differentAddress') {
        setSelectedAddress(2);
      }
    };
    const autoFillAddress = () => {
      if (!differentAddress.value.PostCode || !differentAddress.value.Huisnummer) return;
      const value = {
        postcode: differentAddress.value.PostCode,
        huisnummer: differentAddress.value.Huisnummer,
        land: 'NL'
      };
      fetchAddressLookup(value)
        .then((response) => {
          var hasAddress = response.data.City !== null;
          differentAddress.value.Straatnaam = hasAddress ? response.data.Street : '';
          differentAddress.value.Woonplaats = hasAddress ? response.data.City : '';
          addressLookup.value = hasAddress ? response.data : null;
          validateAllFields();
        })
        .catch(() => {
          addressLookup.value = null;
          differentAddress.value.Straatnaam = '';
          differentAddress.value.Woonplaats = '';
        });
    };
    const validateAllFields = async () => {
      const result = await validate();
    };
    const goToCatalog = () => {
      noProductOverlay.value = false;
      if (router.currentRoute.value.name !== 'aanvullenmagazijnCheckout') {
        router.push('/catalog');
      } else {
        router.push('/aanvullenmagazijn');
      }
    };
    const setSelectedDeliveryDate = (e) => {
      if (!e.currentTarget.value) {
        return;
      }
      store.state.cart.selectedDeliveryDate = e.currentTarget.value;
      if (e.currentTarget.value !== possibleDeliveryDates.value[0].key) {
        isTimeWindowDelivery.value = false;
      }
    };

    watch(
      () => neighborDeliveryStatus,
      (newVal) => {
        setNeighborsDeliveryAllowed(newVal);
      },
      { immediate: true }
    );
    watch(
      () => repeatServiceStatus,
      (newVal) => {
        setRepeatService(newVal);
      },
      { immediate: true }
    );

    return {
      homeAddress,
      deliveryAddress,
      differentAddress,
      siteCode,
      SelectedAddress,
      orderNumber,
      faqs,
      leveringOptions,
      remarks,
      userMarketingPermission,
      buttonText,
      possibleDeliveryDates,
      userWarehouseStatus,
      fetchCheckoutDetailsStore,
      setSelectedAddress,
      setOrderNumber,
      setRepeatService,
      setNeighborsDeliveryAllowed,
      setRemarks,
      setLeveringSubOptions,
      setLeveringOptions,
      setCustomerMarketingPermissionSubOption,
      fetchAddressLookup,
      shoppingCart,
      shoppingCartChanged,
      assortmentFeatureEnabled,
      activeCustomerId,
      prescriberDetails,
      activePpwRecId,
      noProductOverlay,
      popupMessage,
      submitOrderPopupMessage,
      neighborDeliveryStatus,
      repeatServiceStatus,
      validate,
      orderNumberModel,
      isTimeWindowDelivery,
      addressLookup,
      checkDepotIssue,
      addressLookupSuccessful,
      faqsByCustomFilter,
      requireDelivery,
      deliveryDateFeature,
      showNeighborsDeliveryAllowed,
      showAddress,
      showTimeWindowCheck,
      depotIssueCheckboxChecked,
      customerMarketingPermission,
      showDepotIssueBlock,
      isConsignmentOrder,
      updateAddressDetails,
      closeModal,
      fetchCheckoutDetails,
      handleShoppingCartItemUpdate,
      handleShoppingCartItemRemove,
      handleShoppingCartItemAdd,
      handleClearShoppingCart,
      internalSaveCheckout,
      saveCheckout,
      checkRadioAddress,
      autoFillAddress,
      validateAllFields,
      goToCatalog,
      setSelectedDeliveryDate,
      activeAddress,
      remarkType,
      remarkTypeOptions
    };
  }
};
</script>
